export const getters = {
    systemCustomers: state => state.customers,
    Customer: state => state.systemCustomer
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/customers/getters.js